import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import Loader, { FullPageLoader, ModalLoader } from "../../components/common/Loader";
import {
  USER_LIST,
  USER_DELETE,
  USER_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  CATEGORY_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  USER_CHANGE_CHAPTER,
  MEMBER_TYPE_LIST_DROPDOWN,
} from "../../routes/routes";
import {
  PAGINATE,
  NOPAGINATE,
  USER_DELETED,
  USER_CHAPTER_CHANGED,
} from "../../constant/constant";
import { toast } from "react-toastify";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
} from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Image } from "react-bootstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { ValidationMessage, hasRole } from "../../components/Utils";
import moment from "moment";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { styleExcelHeaderRow } from "../../utils/excelStyles";
import StickyTable from "../../components/common/StickyTable";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";

const UserList = () => {
  // ## State Variable Declaration
  const { hasPermission } = usePermission();
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalLoading, setModalLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [userOptions, setUserOptions] = useState({});
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [chapterChangeModal, setChapterChangeModal] = useState(false);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [allChapterOptions, setAllChapterOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});
  const [memberTypeOptions, setMemberTypeOptions] = useState({});
  const [btnExcelDisabled, setBtnExcelDisabled] = useState(false);
  const [filter, setFilter] = useState([]);
  const applyFilter = (next) => {
    setPage(1);
    setFilter(next);
  };

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const selectMemberRef = useRef(null);
  const refFlatpickrJoining = useRef(null);
  const refFlatpickrCreation = useRef(null);
  const [showClearJoiningBtn, setShowClearJoiningBtn] = useState(false);
  const [showClearCreationBtn, setShowClearCreationBtn] = useState(false);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleMemberClear = () => {
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleDateRangeJoiningClear = () => {
    setShowClearJoiningBtn(false);
    if (refFlatpickrJoining.current)
      refFlatpickrJoining.current.flatpickr.setDate([]);
    applyFilter({
      ...filter,
      joining_date_from: "",
      joining_date_to: "",
    });
  };

  const handleCalendarJoiningClick = () => {
    if (refFlatpickrJoining.current) {
      refFlatpickrJoining.current.flatpickr.open();
    }
  };

  const handleDateRangeCreationClear = () => {
    setShowClearCreationBtn(false);
    if (refFlatpickrCreation.current)
      refFlatpickrCreation.current.flatpickr.setDate([]);
    applyFilter({
      ...filter,
      creation_date_from: "",
      creation_date_to: "",
    });
  };

  const handleCalendarCreationClick = () => {
    if (refFlatpickrCreation.current) {
      refFlatpickrCreation.current.flatpickr.open();
    }
  };

  const membershipStatusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "In-Active" },
  ];

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  // const auth_user = JSON.parse(localStorage.getItem("user"));
  // const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  // const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  // const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;

  const columns = [
    { header: "Sl.No.", key: "sno" },
    { header: "Member ID", key: "member_id" },
    { header: "Name", key: "name" },
    { header: "Email", key: "email" },
    { header: "Mobile Number", key: "mobile_number" },
    { header: "Whatsapp Mobile Number", key: "whatsapp_mobile_number" },
    { header: "Company name", key: "company_name" },
    { header: "Address", key: "address" },
    { header: "Bio Description", key: "bio_description" },
    { header: "Our Products and Services", key: "our_products_and_services" },
    { header: "Date of Birth", key: "dob" },
    { header: "Blood Group Name", key: "blood_group_name" },
    { header: "GST Number", key: "gst" },
    { header: "Pan Number", key: "pan" },
  ];
  if (hasRole([1])) {
    columns.push({ header: "Country", key: "country_name" });
  }
  if (hasRole([1, 6])) {
    columns.push({ header: "State", key: "state_name" });
  }
  if (hasRole([1, 6, 7])) {
    columns.push({ header: "Region", key: "region_name" });
  }
  if (hasRole([1, 6, 7, 2])) {
    columns.push({ header: "Chapter", key: "chapter_name" });
  }
  columns.push(
    // { header: "Member Type", key: "member_type_name" },
    { header: "User Role", key: "user_role_name" },
    { header: "Category", key: "category_name" },
    { header: "Date of Joining", key: "date_of_joining" },
    { header: "Date of Creation", key: "created_at" },
    { header: "Member Crowns", key: "crowns_name" },
    { header: "Membership Due Date", key: "membership_due_date" },
    { header: "Website", key: "website" },
    { header: "Instagram Url", key: "instagram_url" },
    { header: "Linkedin Url", key: "linkedin_url" },
    { header: "Twitter Url", key: "twitter_url" },
    { header: "Youtube Url", key: "youtube_url" },
    { header: "Referred By", key: "referred_by_text" },
    { header: "Referrer Name", key: "referrer_name" },
    { header: "Referrer Mobile Number", key: "referrer_mobile" },
    { header: "Membership Status", key: "membership_status_text" },
  );

  const currentDate = moment().format("DD-MM-YYYY");
  const workSheetName = `Members ( ${currentDate} )`;
  const workBookName = "Members List";

  const workbook = new Excel.Workbook();

  const exportAsExcel = async () => {
    try {
      const fileName = workBookName;
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;
      // updated the font and fill for header row cells.
      const headerRow = worksheet.getRow(1);
      styleExcelHeaderRow(headerRow, columns.length);

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 15;
        column.alignment = { horizontal: "center" };
      });
      setBtnExcelDisabled(true);
      await axios
        .get(USER_LIST, {
          params: {
            paging_type: NOPAGINATE,
            isAdmin: 1,
            ...filter,
          },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            const excelData = response.data.data.users;

            if (excelData.length < 1) {
              toast.error("No data found!.");
              return;
            }

            // loop through data and add each one to worksheet
            excelData.forEach((singleData) => {
              worksheet.addRow(singleData);
            });

            // loop through all of the rows and set the outline style.
            worksheet.eachRow({ includeEmpty: false }, (row) => {
              // store each cell to currentCell
              const currentCell = row._cells;
              // loop through currentCell to apply border only for the non-empty cell of excel
              currentCell.forEach((singleCell) => {
                // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                const cellAddress = singleCell._address;
                console.log(singleCell);
                // apply border
                worksheet.getCell(cellAddress).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            });

            // write the content using writeBuffer
            const buf = await workbook.xlsx.writeBuffer();
            // download the processed file
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
          }
        })
        .finally(() => {
          setBtnExcelDisabled(false);
        });
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      toast.error(error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };
  //end

  const navigate = useNavigate();
  const HandleDelete = async (userId) => {
    try {
      axios
        .delete(USER_DELETE + userId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(USER_DELETED);
            setRefresh((prevRefresh) => !prevRefresh);
            navigate("/users");
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            toast.error(err.response.data.msg);
          }
        });
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };

  const updateChapterSubmit = () => {
    setModalLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(USER_CHANGE_CHAPTER, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setChapterChangeModal(false);
          setErrors({});
          setRefresh((prevRefresh) => !prevRefresh);
          toast.success(USER_CHAPTER_CHANGED);
          navigate("/users");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          const error = err.response.data.error;
          setErrors(error || {});
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => {
        setModalLoading(false);
        setBtnDisabled(false);
      });
  };

  /**
   * @API User List API's call
   */
  useEffect(() => {
    setLoading(true);
    axios
      .get(USER_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.users);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          },
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

        // Fetch chapter data
        const allchapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            show_all: 1,
          },
        });
        const fetchedAllChapterOptions = allchapterResponse.data.data;
        setAllChapterOptions(fetchedAllChapterOptions);

        // Fetch category data
        const categoryResponse = await axios.get(CATEGORY_LIST_DROPDOWN);
        const fetchedCategoryOptions = categoryResponse.data.data;
        setCategoryOptions(fetchedCategoryOptions);

        // Fetch member type data
        // const memberTypeResponse = await axios.get(MEMBER_TYPE_LIST_DROPDOWN);
        // const fetchedMemberTypeOptions = memberTypeResponse.data.data;
        // setMemberTypeOptions(fetchedMemberTypeOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, filter, refresh, perPage]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Members</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Members List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission("members-create") && (
                  <Link to={"/user/create"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                )}
                {hasPermission("members-list-export") && (
                  <button
                    disabled={btnExcelDisabled}
                    type="button"
                    onClick={exportAsExcel}
                    className="btn rounded-pill btn-primary excel-btn ibutton"
                  >
                    <span className="tf-icons bx bxs-spreadsheet"></span>&nbsp;
                    Excel
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>Members List</h5>
          </div> */}

          <div className="container-fluid f_containter">
            <div className="row mb-2">
              {hasRole([1]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      applyFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      applyFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="region_id">
                    Region
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectRegionRef}
                    name="region_id"
                    isClearable
                    options={regionOptions}
                    onChange={(selected) => {
                      handleChapterClear();
                      applyFilter({
                        ...filter,
                        region_id: selected?.value,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="chapter_id">
                    Chapter
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectChapterRef}
                    name="chapter_id"
                    isClearable
                    options={chapterOptions}
                    onChange={(selected) => {
                      handleMemberClear();
                      applyFilter({
                        ...filter,
                        chapter_id: selected?.value,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {/* <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="member_type">
                  Member Type
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="member_type"
                  isClearable
                  options={memberTypeOptions}
                  onChange={(selected) =>
                    applyFilter({ ...filter, member_type: selected?.value })
                  }
                />
              </div> */}

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="gender">
                  Gender
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="gender"
                  inputId="gender"
                  isClearable
                  options={genderOptions}
                  value={
                    genderOptions.find(
                      (option) => option.value === filter.gender,
                    ) || null
                  }
                  onChange={(selected) => {
                    applyFilter({ ...filter, gender: selected?.value });
                  }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="user_id">
                  Member
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  ref={selectMemberRef}
                  name="user_id"
                  isClearable
                  options={userOptions}
                  onChange={(selected) =>
                    applyFilter({ ...filter, user_id: selected?.value })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="category_id">
                  Category
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="category_id"
                  isClearable
                  options={categoryOptions}
                  onChange={(selected) =>
                    applyFilter({ ...filter, category_id: selected?.value })
                  }
                />
              </div>

              <div className="col-md-3 mb-3">
                <label className="form-label" htmlFor="status_id">
                  Membership Status
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  name="status_id"
                  isClearable
                  options={membershipStatusOptions}
                  onChange={(selected) =>
                    applyFilter({ ...filter, status_id: selected?.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label" htmlFor="date_range_joining">
                    Date of Joining
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickrJoining}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearJoiningBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              applyFilter({
                                ...filter,
                                joining_date_from: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                joining_date_to: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearJoiningBtn(false);
                            }
                          },
                        }}
                        placeholder="Joining Date Range"
                      />
                      {showClearJoiningBtn && (
                        <button
                          type="button"
                          className="border-0 clearDateRangeBtn"
                          title="Clear"
                          onClick={handleDateRangeJoiningClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div
                      className="cal_icon"
                      onClick={handleCalendarJoiningClick}
                    >
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label" htmlFor="date_range_creation">
                    Date of Creation
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickrCreation}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearCreationBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              applyFilter({
                                ...filter,
                                creation_date_from: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                creation_date_to: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearCreationBtn(false);
                            }
                          },
                        }}
                        placeholder="Creation Date Range"
                      />
                      {showClearCreationBtn && (
                        <button
                          type="button"
                          className="border-0 clearDateRangeBtn"
                          title="Clear"
                          onClick={handleDateRangeCreationClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div
                      className="cal_icon"
                      onClick={handleCalendarCreationClick}
                    >
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="search">
                    Search
                  </label>
                  <input
                    type="text"
                    className="form-control hide-arrow"
                    id="search"
                    placeholder="Search by Member ID, Name, Mobile Number"
                    onChange={(e) =>
                      applyFilter({ ...filter, search: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
          <StickyTable refreshDeps={[data, loading]}>
            <table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Profile Image</th>
                  <th>Member ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  {/* <th>Member Type</th> */}
                  <th>Category</th>
                  <th>Membership Status</th>
                  <th>Date of Joining</th>
                  <th>Date of Creation</th>
                  <th>Membership Due Date</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="15" />
                ) : data.length > 0 ? (
                  data.map((user, i) => (
                    <tr key={i}>
                      <td>{user?.sno}</td>
                      <td>
                        <Image
                          width={80}
                          height={80}
                          src={user?.profile_image}
                          rounded
                        />
                      </td>
                      <td>{user?.member_id}</td>
                      <td>{user?.name}</td>
                      <td>{user?.mobile_number}</td>
                      {hasRole([1]) && <td>{user?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{user?.state_name || "Tamil Nadu"}</td>}
                      {hasRole([1, 6, 7]) && <td>{user?.region_name}</td>}
                      {hasRole([1, 6, 7, 2]) && <td>{user?.chapter_name}</td>}
                      {/* <td>{user?.member_type_name}</td> */}
                      <td className="word-wrap">{user?.category_name}</td>
                      <td>{user?.membership_status_text}</td>
                      <td>{user?.date_of_joining}</td>
                      <td>{user?.created_at}</td>
                      <td>{user?.membership_due_date}</td>
                      <td style={{ textAlign: "right" }}>
                        {hasPermission("members-edit") && (
                          <button
                            className="badge bg-label-warning me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Change Chapter"
                            data-bs-original-title="Change Chapter"
                            onClick={() => {
                              setErrors({});
                              setModalLoading(false);
                              setChapterChangeModal(true);
                              setForm({
                                id: user?.id,
                                name: user?.name,
                                member_id: user?.member_id,
                                company_name: user?.company_name,
                                from_chapter_id: user?.chapter_id,
                                from_chapter_id_selected: {
                                  value: Number(user?.chapter_id),
                                  label: user?.chapter_name,
                                },
                              });
                            }}
                          >
                            <i className="bx bx-refresh"></i>
                          </button>
                        )}

                        <button
                          className="badge bg-label-info me-1 border-0"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="View"
                          data-bs-original-title="View"
                          onClick={() => {
                            setDetailModal(true);
                            setDetailData(user);
                          }}
                        >
                          <i className="bx bx-show"></i>
                        </button>

                        {hasPermission("members-edit") && (
                          <Link to={`/user/${user.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {hasPermission("members-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(user?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="15" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1A4331"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1 d-flex align-items-center gap-3"
          >
            <span>Member Details</span>
            {detailData?.profile_image && (
              <Image
                width={50}
                height={50}
                src={detailData?.profile_image}
                rounded
                style={{ objectFit: "cover" }}
              />
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Member ID</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.member_id)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Gender</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(
                      detailData.gender
                        ? detailData.gender.charAt(0).toUpperCase() +
                            detailData.gender.slice(1)
                        : "",
                    )}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Email</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.email)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Mobile Number</label>

                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.mobile_number)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">
                    Whatsapp Mobile Number
                  </label>

                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.whatsapp_mobile_number)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Company name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.company_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Address</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.address)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Bio Description</label>
                  <span
                    className="d-block font-weight-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {checkEmptyOrNull(detailData.bio_description)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">
                    Our Products and Services
                  </label>
                  <span
                    className="d-block font-weight-600"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {checkEmptyOrNull(detailData.our_products_and_services)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Birth</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.dob)}
                  </span>
                </div>
              </div>

              {hasRole([1]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Country</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.country_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">State</label>
                    <span className="d-block font-weight-600">
                      {detailData.state_name || "Tamil Nadu"}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Region</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.region_name)}
                    </span>
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="col-md-4">
                  <div className="mb-4">
                    <label className="form-label m-0">Chapter</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.chapter_name)}
                    </span>
                  </div>
                </div>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">User Role</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.user_role_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Category</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.category_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Member Crowns</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.crowns_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Joining</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.date_of_joining)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Date of Creation</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.created_at)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Due Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_due_date)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Blood Group</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.blood_group_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">GST Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.gst)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Pan Number</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.pan)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Website</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.website)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Instagram Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.instagram_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Linkedin Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.linkedin_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Twitter Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.twitter_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Youtube Url</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.youtube_url)}
                  </span>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Referred By</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.referred_by_text)}
                  </span>
                </div>
              </div>

              {detailData.referred_by === 3 && (
                <>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Name</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.referrer_name)}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Mobile</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.referrer_mobile)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              {detailData.referred_by === 2 && (
                <>
                  <div className="col-md-4">
                    <div className="mb-4">
                      <label className="form-label m-0">Referrer Name</label>
                      <span className="d-block font-weight-600">
                        {checkEmptyOrNull(detailData.ref_member_name)} -{" "}
                        {checkEmptyOrNull(detailData.ref_member_region)} -{" "}
                        {checkEmptyOrNull(detailData.ref_member_chapter)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Membership Status</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.membership_status_text)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={chapterChangeModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setChapterChangeModal(false);
          setErrors({});
          setModalLoading(false);
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Change Chapter
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ position: "relative" }}>
          <ModalLoader visible={btnDisabled || modalLoading} />
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="user_id">
                    Member<span className="text-danger">*</span>
                  </label>
                  <div>
                    {form?.name} - {form?.member_id} ({form?.company_name} )
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="from_chapter_id">
                    From Chapter<span className="text-danger">*</span>
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="from_chapter_id"
                    isDisabled={true}
                    options={allChapterOptions}
                    value={form?.from_chapter_id_selected}
                    onChange={(selected) => {
                      setForm({
                        ...form,
                        from_chapter_id: selected?.value,
                      });
                    }}
                  />
                  <ValidationMessage error={errors} name="from_chapter_id" />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="to_chapter_id">
                    To Chapter<span className="text-danger">*</span>
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="to_chapter_id"
                    isClearable
                    // options={allChapterOptions}
                    options={
                      Array.isArray(allChapterOptions)
                        ? allChapterOptions.filter(
                            (option) => option.value !== form.from_chapter_id,
                          )
                        : []
                    }
                    onChange={(selected) => {
                      setForm({
                        ...form,
                        to_chapter_id: selected?.value,
                      });
                    }}
                  />
                  <ValidationMessage error={errors} name="to_chapter_id" />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="chapter_changed_date">
                    Chapter Changed Date<span className="text-danger">*</span>
                  </label>
                  <Flatpickr
                    className="form-control"
                    options={{
                      dateFormat: "Y-m-d",
                      enableTime: false,
                      maxDate: "today",
                      onChange: (selected) =>
                        setForm({
                          ...form,
                          chapter_changed_date: moment(selected[0]).format(
                            "YYYY-MM-DD",
                          ),
                        }),
                    }}
                    value={detailData?.chapter_changed_date}
                    placeholder="Select Chapter Changed Date"
                  />
                  <ValidationMessage
                    error={errors}
                    name="chapter_changed_date"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            data-bs-dismiss="modal"
            disabled={btnDisabled}
            onClick={() => updateChapterSubmit(detailData?.id)}
          >
            Update
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => {
              setChapterChangeModal(false);
              setErrors({});
              setModalLoading(false);
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserList;
